import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "app-navbar flex-shrink-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "app-navbar-item align-items-stretch ms-1 ms-lg-3" }, null, -1)
const _hoisted_3 = { class: "app-navbar-item ms-1 ms-lg-3" }
const _hoisted_4 = {
  href: "#",
  class: "btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px",
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_5 = {
  key: 0,
  class: "svg-icon theme-dark-hide svg-icon-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-sun-fill" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "svg-icon theme-light-hide svg-icon-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-moon-fill" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  class: "app-navbar-item ms-1 ms-lg-3 mt-1",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_12 = {
  class: "btn btn-light btn-hover-rise cursor-pointer symbol symbol-35px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_13 = { class: "text-muted fw-bold font-size-base d-none d-md-inline mr-1" }
const _hoisted_14 = {
  key: 0,
  class: "fw-bold font-size-base d-none d-md-inline ms-2"
}
const _hoisted_15 = {
  key: 1,
  class: "fw-bold font-size-base d-none d-md-inline ms-2"
}
const _hoisted_16 = {
  key: 2,
  class: "fa-solid fa-graduation-cap d-none d-md-inline ms-2"
}
const _hoisted_17 = {
  key: 3,
  class: "fa-solid fa-gears d-none d-md-inline ms-2"
}
const _hoisted_18 = {
  key: 4,
  class: "fa-solid fa-person-chalkboard d-none d-md-inline ms-2"
}
const _hoisted_19 = {
  key: 5,
  class: "fa-solid fa-id-card-clip d-none d-md-inline ms-2"
}
const _hoisted_20 = {
  key: 6,
  class: "fa-solid fa-building d-none d-md-inline ms-2"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold font-size-base d-inline d-md-none" }, "Menu", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTThemeModeSwitcher = _resolveComponent("KTThemeModeSwitcher")!
  const _component_UserAccountMenu = _resolveComponent("UserAccountMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, [
        (_ctx.themeMode === 'light')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
      ]),
      _createVNode(_component_KTThemeModeSwitcher)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('navbar.userGreeting')), 1),
        (_ctx.user.userType === 'anon')
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Visiteur"))
          : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.user.prenom) + " " + _toDisplayString(_ctx.user.nom), 1)),
        (['student', 'parent', 'admissible'].includes(_ctx.user.userType))
          ? (_openBlock(), _createElementBlock("i", _hoisted_16))
          : _createCommentVNode("", true),
        (_ctx.user.userType === 'admin')
          ? (_openBlock(), _createElementBlock("i", _hoisted_17))
          : _createCommentVNode("", true),
        (_ctx.user.userType === 'intervenant')
          ? (_openBlock(), _createElementBlock("i", _hoisted_18))
          : _createCommentVNode("", true),
        (_ctx.user.userType === 'staff')
          ? (_openBlock(), _createElementBlock("i", _hoisted_19))
          : _createCommentVNode("", true),
        (_ctx.user.userType === 'company')
          ? (_openBlock(), _createElementBlock("i", _hoisted_20))
          : _createCommentVNode("", true),
        _hoisted_21
      ]),
      _createVNode(_component_UserAccountMenu)
    ])
  ]))
}